export enum SystemView {
  HOME = "Home",
  TEMPLATES = "Templates",
  FORM_TEMPLATE = "FormTemplate",
  LIST = "List",
  INFO_GROUP = "InfoGroup",
  USER_TEMPLATE = "UserTemplate",
  USER = "User",
  ROLES = "Roles",
  SERVICES_TEMPLATE = "ServicesTemplate",
  SESSION_TEMPLATES = "SessionTemplates",
  PROMPTS = "Prompts",
  CUPS_PRICE_LEVEL = "CupsPriceLevel",
  SPACE = "Space",
  SAVE_SPACE = "SaveSpace",
  PROFILE = "Profile",
  SAVE_ORDER_TEMPLATE = "SaveOrderTemplate",
  MEDICAL_ORDER = "MedicalOrder",
  LOAD_ORDERS = "LoadOrders",
  ADMIN_DASHBOARD = "AdminDashboard",
  DASHBOARD_TEMPLATES = "DashboardTemplates",
  DASHBOARD = "Dashboard",
  CAMPUS = "Campus",
  SAVE_CAMPUS = "SaveCampus",
  DEPENDENCIES = "Dependencies",
  SAVE_DEPENDENCIES = "SaveDependencies",
  AVAILABILITY = "Availability",
  DOCTOR_PROFILE = "DoctorProfile",
  NOTIFICATION_TEMPLATE = "NotificationTemplate",
  TEMPLATE_PDF = "TemplatePdf",
  GENERAL_RULES = "GeneralRules",
  MULTIMEDIA = "Multimedia",
  ACTION_PLAN = "ActionPlan",
  ABOUT = "About",
  LOGIN = "Login",
  REGISTER = "Register",
  VIEW_INTELLETICKS = "ViewIntelliticks",
  LOAD_DOCUMENT = "LoadDocument"
}

export interface ProfileRouteParams {
  id?: string;
  service?: string;
  [key: string]: any;
}

export interface UserRouteParams {
  userDocument?: string;
  userId?: string;
  [key: string]: any;
}

export interface ListRouteParams {
  id?: string;
  [key: string]: any;
}

export interface SaveSpaceRouteParams {
  id?: string;
  [key: string]: any;
}

export interface SaveCampusRouteParams {
  id?: string;
  [key: string]: any;
}

export interface SaveDependenciesRouteParams {
  id?: string;
  [key: string]: any;
}

export interface DoctorProfileRouteParams {
  id?: string;
  [key: string]: any;
}

export interface RegisterRouteParams {
  type?: string;
  info?: string;
  userId?: string;
  [key: string]: any;
}

export interface IntelliticksRouteParams {
  key?: string;
  [key: string]: any;
}
